import { Accordion } from "../components/Accordion";

export const Faq = () => {
    

  return (
    <div className="">
        <div>
            <h1 className="text-3xl text-center font-bold text-primary-700">Frequently Asked Questions</h1>
        </div>
        <Accordion />
    
    </div>

  )
}
